<template>
    

    <div>
        <div v-if="is_super_admin" class="my-table-style">
            <el-table
            :data="settledList"
            style="width: 100%;border-color:'#606266'"
            
            :default-sort = "{prop: 'date', order: 'descending'}"
            :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
            :cell-style="{color: '#666',fontSize:'14px'}"
            border
            >

                <el-table-column
                fixed
                align="center"
                prop="settled_name"
                label="申请人姓名"
                sortable
                >
                </el-table-column>


                <el-table-column
                fixed
                align="center"
                prop="settled_phone"
                label="电话"
                sortable
                >
                </el-table-column>

                <el-table-column
                fixed
                align="center"
                prop="settled_email"
                label="邮箱"
                sortable
                >
                </el-table-column>

                <el-table-column
                fixed
                align="center"
                prop="settled_explain"
                label="加盟说明"
                sortable
                >
                </el-table-column>

                <el-table-column
            align="center"
            label="操作"
            >
            <template slot-scope="scope">
                <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteSettled(scope.row)">删除</el-button>
            </template>
            </el-table-column>

            </el-table>

            <el-pagination
            @current-change="changeCurrent"
            :current-page="iCurrentPage"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="iMaxTotal"
            style="text-align:right; margin-top:15px"
            >
            </el-pagination>

        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
export default {
    name: 'SettledSystem',
    data() {
        return {

            iCurrentPage: 1,
            iMaxTotal: 10,
            settledList: [],
            is_super_admin: false,

        }
    },

    mounted() {
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
        this.is_super_admin = true
        }
        // 获取加盟的商家列表
        this.getSettledList()
    },

    methods: {
        // 获取加盟商家的列表
        async getSettledList() {
            let d_params = {
                'page': this.iCurrentPage,
                'page_size': 10,
            }

            const res = await this.$axios.get('/api/settled/', {params: d_params});
            this.settledList = res.data.results;
            this.iMaxTotal = res.data.count;

            console.log(this.settledList)

        },
         // 分页事件
        changeCurrent(val){
            this.iCurrentPage = val;
            this.getFeedbackList();
        },
        
        // 删除操作
        async deleteSettled(row){
        // console.log(index)

            var _this = this
            this.$confirm('此操作将永久删除该岗位', '删除岗位警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error'
            }).then(() => {
            _this.$axios.delete('/api/settled/' + row.settled_id + '/').then(
                function(res){
                _this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                _this.getSettledList()
                }
            )
            }).catch(() => {
            _this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });
        }
    
    }
    

}



</script>